module.exports = __webpack_public_path__ + "img/t_1.00becff1.png";